import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AiTrainerAuthProvider } from '@/contexts/AiTrainerAuthContext';
import RequireTrainer from '@/components/AiTrainer/RequireTrainer';
import LoginPage from '@/components/AiTrainer/LoginPage';
import RegisterPage from '@/components/AiTrainer/RegisterPage';
import PendingPage from '@/components/AiTrainer/PendingPage';
import ExamCorpusPage from '@/Pages/ExamCorpusPage';
import CurriculumPage from '@/Pages/CurriculumPage';
import ActivityPage from '@/Pages/ActivityPage';
import { TrainerLayout } from '@/components/Layout/TrainerSidebar';
import TrainerPlaceholder from '@/components/AiTrainer/TrainerPlaceholder';

/**
 * Standalone router for the trainer portal.
 *
 * Three public routes (login / register / pending) and one gated route
 * (the upload library). Anything else 404s back to /library so the
 * URL is predictable.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AiTrainerAuthProvider>
        <Routes>
          {/* Public auth surface */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/pending"  element={<PendingPage />} />

          {/* Trainer-only surfaces — all live under the sidebar layout. */}
          <Route
            element={
              <RequireTrainer>
                <TrainerLayout>
                  <Outlet />
                </TrainerLayout>
              </RequireTrainer>
            }
          >
            <Route path="/library"    element={<ExamCorpusPage />} />
            <Route path="/curriculum" element={<CurriculumPage />} />
            <Route path="/activity"   element={<ActivityPage />} />
            <Route path="/profile"  element={<TrainerPlaceholder eyebrow="Account · Profile" title="Your trainer profile" subtitle="Name, organisation, and account status." />} />
            <Route path="/help"     element={<TrainerPlaceholder eyebrow="Trainer · Help"    title="How the corpus works" subtitle="Tag, upload, and let the RAG engine take it from there." />} />
          </Route>

          {/* Defaults */}
          <Route path="/" element={<Navigate to="/library" replace />} />
          <Route path="*" element={<Navigate to="/library" replace />} />
        </Routes>
      </AiTrainerAuthProvider>
    </BrowserRouter>
  );
}
